/* jslint browser: true,  devel: true */
import moment from "moment";
import $ from "jquery";

window.msNews.controller("ArticleCtrl", [
  "$scope",
  "$rootScope",
  "$state",
  "$stateParams",
  "newsApi",
  "backend.config",
  "apiFiles",
  "$utils",
  "toastr",
  function(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    newsApi,
    backend,
    apiFiles,
    $utils,
    toastr
  ) {
    console.log("ArticleCtrl:init as Article");

    const utils = $utils($scope);

    $scope.$root.currentTitle = {};

    // $scope.isPreview = $state.current.name === 'news.preview'
    $scope.isPreview = $stateParams.articleId === "preview";

    if ($scope.isPreview) {
      this.data = {
        ...window._previewArticle,
        commentsEnabled: false,
        likesEnabled: false
      };
      $scope.$root.currentTitle = { Preview: this.data.headline };
      const _returnTo = this.data._returnTo || ["Articles", "#/articleEditor"];
      [$scope.backText, $scope.backPath] = _returnTo;
    } else {
      loadArticle();
    }

    $scope.moment = moment;

    function setupClickListener() {
      // Intercept link clicks to append token if needed (for SSO links)
      setTimeout(() => {
        $(".article-box .article-summary").on("click", "a", evt => {
          const a = evt.currentTarget;
          const orig = a.href;
          if (
            a.href.startsWith(API_URL) &&
            a.href.match(/.+\/sso\/redirect\/[^/]+\/[^/]+\/[^/]+/)
          ) {
            a.href = orig + "?t=" + backend.token;
            setTimeout(() => {
              a.href = orig;
            }, 0);
          }
          return true;
        });
      }, 0);
    }

    function loadArticle() {
      return newsApi
        .get({ articleId: $stateParams.articleId })
        .then(function(article) {
          if (!article) {
            window.location.hash = "#/";
            toastr.error("Article not found");
            return;
          }
          $scope.Article.data = article;
          $scope.$root.currentTitle = { News: article.headline };
          setupClickListener();
          return article;
        });
    }

    function getNewComment(extra = {}) {
      return {
        name: $scope.userdata.firstName + " " + $scope.userdata.lastName,
        replies: [],
        _new: true,
        _isReply: false,
        ...extra
      };
    }

    function focusComment(id, flash) {
      setTimeout(function() {
        var el = document.getElementById("comment_" + id);
        if (el.scrollIntoViewIfNeeded) {
          el.scrollIntoViewIfNeeded({ behavior: "smooth" });
        } else {
          el.scrollIntoView({ behavior: "smooth" });
        }
        el.focus();

        if (flash) {
          var comment = el.closest(".article-comment");
          comment.classList.add("flash-comment");
          setTimeout(function() {
            comment.classList.remove("flash-comment");
          }, 2000);
        }
      }, 50);
    }

    function getLatestComment(comments) {
      if (!comments) return -1;
      return comments.reduce(
        (acc, v) => Math.max(acc, v.commentId, getLatestComment(v.replies)),
        0
      );
    }

    $scope.getArticleHTML = () => {
      return utils.getSanitizedHTML(
        utils.fixLocalLinks($scope.Article.data.fullText)
      );
    };

    // TODO
    $scope.defaultAvatarUrl =
      "http://forums.wholehogsports.com/styles/we_universal/theme/images/no_avatar.gif";

    $scope.newComment = getNewComment();
    $scope.showReplyFor = null;

    $scope.replyTo = function(id) {
      $scope.showReplyFor = id;
      $scope.newReply = getNewComment({ _isReply: true, replyToCommentId: id });
      focusComment("reply");
    };

    $scope.flag = function(comment) {
      newsApi
        .flagComment(comment)
        .then(loadArticle)
        .then(function() {
          focusComment(comment.commentId);
        });
    };

    $scope.cancelReply = function() {
      $scope.showReplyFor = null;
      $scope.newReply = null;
    };

    $scope.send = function(comment) {
      newsApi
        .addComment({
          newsItemId: $scope.Article.data.id,
          commentText: comment.commentText,
          replyToCommentId: comment.replyToCommentId
        })
        .then(loadArticle)
        .then(function(article) {
          $scope.newComment = getNewComment();
          $scope.cancelReply();
          var id = getLatestComment(article.comments);
          console.log("Latest comment id found", id);
          focusComment(id, true);
        });
    };

    $scope.editArticle = function(article) {
      window.location.href =
        "#/articleEditor/edit/" + article.articleId + "/" + article.version;
    };

    $scope.imageURLs = {};
    $scope.getPreview = function(article) {
      if (!article) return "";
      const url = article.previewImgUrl || article.fullImgUrl;
      if (!article.imageWasUploaded) {
        return url;
      }
      if (!$scope.imageURLs[url]) {
        $scope.imageURLs[url] = {};
        apiFiles.getLocalURL(url).then(imgUrl => {
          $scope.imageURLs[url].url = imgUrl;
        });
      }
      return $scope.imageURLs[url] && $scope.imageURLs[url].url;
    };

    $scope.toggleLike = function(article, $event) {
      $scope.$parent.toggleLike(article, $event).then(() => {
        loadArticle();
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/apps/news/controllers/article.js